export const RESOLVE_PARTNER_CODE_EVENT = "kayros:resolve-partner-code";
export const PARTNER_CODE_RESOLVED_EVENT = "kayros:partner-code-resolved";

const dispatchResolved = (doc, detail) => {
  if (!doc || !doc.dispatchEvent) return;
  doc.dispatchEvent(new CustomEvent(PARTNER_CODE_RESOLVED_EVENT, { detail }));
};

/**
 * Lets a screen script ask whether a discount code is accepted on the current
 * process. The script stays in the screen HTML; the lookup itself is shared.
 */
export const bindPartnerCodeEvents = (doc, { resolve }) => {
  if (!doc || !doc.addEventListener) return () => {};

  const onResolve = (event) => {
    const detail = (event && event.detail) || {};
    const requestId = detail.requestId;
    if (!requestId) return;
    Promise.resolve()
      .then(() => resolve(detail.code))
      .then((match) => {
        dispatchResolved(doc, { requestId, match: match || null });
      })
      .catch(() => {
        dispatchResolved(doc, { requestId, match: null });
      });
  };

  doc.addEventListener(RESOLVE_PARTNER_CODE_EVENT, onResolve);
  return () => {
    doc.removeEventListener(RESOLVE_PARTNER_CODE_EVENT, onResolve);
  };
};
